import { useStartupParamsStore } from "@/store/startupParams";

type GoalShareVariant = "active" | "completed";

interface ShareGoalParams {
  variant: GoalShareVariant;
  rewardAmount: number;
  ridesRequired: number;
}

export const useShareGoal = () => {
  const serviceType = useStartupParamsStore((state) => state.serviceType);

  return ({ variant, rewardAmount, ridesRequired }: ShareGoalParams) => {
    const isTariffEda = serviceType === "eats";
    const reward = `${rewardAmount}₽`;
    const rides = isTariffEda ? "заказов" : "поездок";
    const park = isTariffEda ? "БК Еде" : "БТ";
    const GOAL_SHARE_BOT_LINK = isTariffEda
      ? "https://t.me/BK_EdaBot?start=utm_personalGoalEda"
      : "https://t.me/BogatiyTaxistBot?start=utm_personalGoal";
    const text =
      variant === "completed"
        ? `Добил цель от БТ💪 \n${reward} теперь у меня) \n\nПолучить цель тут👇\n${GOAL_SHARE_BOT_LINK}`
        : `Смотрите, какую цель в ${park} выбил \n${reward} за ${ridesRequired} ${rides}, это же прям изи \n\nПолучить цель тут👇\n${GOAL_SHARE_BOT_LINK}`;
    const encodedText = encodeURIComponent(text);

    window.open(`https://t.me/share/url?url=${encodedText}`, "_blank");
  };
};
